import {Component, OnInit, Inject} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

import {HttpService} from '../services/HttpService';
import {NotificationService} from '../services/NotificationService';


@Component({
    selector: 'app-edit-user',
    templateUrl: './edit-user.component.html',
    styleUrls: ['./edit-user.component.scss'],
    providers: [HttpService, NotificationService]
})
export class EditUserComponent implements OnInit {
    public userDetails: any;
    public User_Details: any;
    public loading: boolean = false;
    public statusOptions =
        [{'value': 0, 'name': 'Deleted'}, {'value': 1, 'name': 'Active'}];

    constructor(
        public dialogRef: MatDialogRef<EditUserComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public http: HttpService,
        public notification: NotificationService,
    ) {
    }

    ngOnInit() {

        this.User_Details = JSON.parse(localStorage.getItem('Admin_User_Details'));
        this.userDetails = JSON.parse(JSON.stringify(this.data.userDetails));
        console.log(this.data);
    }

    closeDialog() {
        this.dialogRef.close({changedUser: this.userDetails});
    }

    updateUser() {
        this.loading = true;
        this.http.makeRequestPost(['admin/user/update', {
            token: this.User_Details.token,
            id: this.userDetails.id,
            name: this.userDetails.name,
            surname: this.userDetails.surname,
            phone: this.userDetails.phone,
            email: this.userDetails.email,
            active: this.userDetails.active,
        }])
        .subscribe(
            (response) => {
                this.loading = false;
                if (response.data) {
                    this.closeDialog();
                } else {
                    this.notification.showNotification('Could not update user details', 'Error', 'error');
                }
                this.closeDialog();
            },
            (error) => {
                this.loading = false;
                this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
            }
        )
    }

}



// WEBPACK FOOTER //
// ./src/app/edit-user/edit-user.component.ts